// removed by extract-text-webpack-plugin
module.exports = {"intro":"_293uR","copy":"_1D2HL","copy--light":"_1w3FN","copy--dark":"_3wp-Q","disclaimer":"_2szqF _1D2HL"};


/*****************
 ** WEBPACK FOOTER
 ** ./components/Intro/styles.css
 ** module id = 340
 ** module chunks = 0
 **/